module.exports = __webpack_public_path__ + "static/media/bf2.6e646c37.png";